import { ConditionEffects, Conditions } from 'consts/autochartConsts'

export const createBlankCondition = ({ type, createdBy }) => {
  const createdAt = new Date().toISOString()
  return {
    type,
    note: '',
    properties: {},
    createdBy,
    editedBy: createdBy,
    surfaces: [],
    createdAt,
    updatedAt: createdAt
  }
}

export const validateCondition = condition => {
  const errors = []

  if (!condition?.type) {
    errors.push({ field: 'type', error: 'missing-value' })
    return errors
  }

  if (Conditions[condition.type].requireTextualNote && !condition.note) {
    errors.push({ field: 'note', error: 'missing-value' })
    return errors
  }

  const conditionDefinition = Conditions[condition.type]

  if (conditionDefinition.effect === ConditionEffects.Surfaces && !condition.surfaces?.length) {
    errors.push({ field: 'surfaces', error: 'missing-value' })
  }

  if (conditionDefinition.severityOptions && !condition.properties?.severity) {
    errors.push({ field: 'properties.severity', error: 'missing-value' })
  }

  return errors
}

const DEFAULT_TOOTH_NUMBERING_BY_COUNTRY = {
  US: 'universal',
  AU: 'fdi'
}

const resolveCountryCode = country => {
  if (!country) return null
  const c = String(country).toLowerCase()
  if (c === 'us' || c.includes('united states')) return 'US'
  if (c === 'au' || c.includes('australia')) return 'AU'
  return null
}

export const getPracticeToothNumberingSystem = ({ appSettings, country }) => {
  let settings = {}
  try {
    settings = typeof appSettings === 'string' ? JSON.parse(appSettings || '{}') : appSettings || {}
  } catch (e) {
    settings = {}
  }

  const configured = settings?.autochartSettings?.toothNumberingSystem
  if (configured === 'fdi' || configured === 'universal') return configured

  const code = resolveCountryCode(country)
  return (code && DEFAULT_TOOTH_NUMBERING_BY_COUNTRY[code]) || 'universal'
}

const UNIVERSAL_TO_FDI_MAP = {
  1: '18',
  2: '17',
  3: '16',
  4: '15',
  5: '14',
  6: '13',
  7: '12',
  8: '11',
  9: '21',
  10: '22',
  11: '23',
  12: '24',
  13: '25',
  14: '26',
  15: '27',
  16: '28',
  17: '38',
  18: '37',
  19: '36',
  20: '35',
  21: '34',
  22: '33',
  23: '32',
  24: '31',
  25: '41',
  26: '42',
  27: '43',
  28: '44',
  29: '45',
  30: '46',
  31: '47',
  32: '48'
}

export const formatToothNumberLabel = ({ universalNumber, system = 'universal' }) => {
  if (!universalNumber) return ''
  if (system === 'fdi') return UNIVERSAL_TO_FDI_MAP[Number(universalNumber)] || String(universalNumber)
  return String(universalNumber)
}
